import { Component, OnInit } from '@angular/core';
import { MetaService } from '@ngx-meta/core';
import { CanonicalService } from '../../shared/services/canonical.service';
import { RACKEO_SITE } from '../../shared/rackeo-site';

@Component({
  selector: 'app-empresa-data-center',
  templateUrl: './empresa-data-center.component.html',
  styleUrls: ['./empresa-data-center.component.scss']
})
export class EmpresaDataCenterComponent implements OnInit {
  readonly imgBanner = 'assets/images/rackeo/empresa/data-center/banner-nuestro-data-center.png';
  readonly imgServidores = 'assets/images/rackeo/empresa/data-center/polaroid-servidores-dell.png';
  readonly imgGenerador = 'assets/images/rackeo/empresa/data-center/polaroid-generador-respaldo.png';
  readonly imgUps = 'assets/images/rackeo/empresa/data-center/polaroid-ups-eaton.png';

  constructor(
    private readonly meta: MetaService,
    private readonly canonical: CanonicalService
  ) {}

  ngOnInit(): void {
    this.meta.setTitle('Empresa | Nuestro Data Center | Rackeo');
    this.meta.setTag('description', 'Infraestructura Rackeo: data center propio en Chile, fibra óptica, respaldo eléctrico, climatización, seguridad y redundancia para tus servidores.');
    this.meta.setTag('og:type', 'website');
    this.meta.setTag('og:image:type', 'image/png');
    this.meta.setTag('og:image', RACKEO_SITE.ogImageUrl);
    this.meta.setTag('og:image:width', '1200');
    this.meta.setTag('og:image:height', '1200');
    this.meta.setTag('og:image:alt', 'Empresa | Nuestro Data Center | Rackeo');
    this.meta.setTag('og:locale', RACKEO_SITE.ogLocale);
    this.canonical.set('/empresa/data-center');
  }
}
